/**
 * Purchase order line item. Subcollection: org/{orgId}/purchase-order/{purchaseOrderId}/item
 * Resolve the repository with context { orgId, purchaseOrderId }.
 *
 * Owned child row (no lifecycle). Audit via {@link Auditable} / ChildCrudService.
 * Invariants (totals, ≥1 item) are enforced in purchaseOrderService.
 *
 * Product reference follows canonical {@link ProductRef}: `productId` + optional
 * **partial** `variantId` (identifying axes; size lives on `PurchaseOrderItemBreakdown`).
 */
export const PURCHASE_ORDER_ITEM = 'PurchaseOrderItem';
//# sourceMappingURL=purchase-order-item.js.map